async function copyText(text: string) {
  // modern API
  if (
    typeof navigator !== 'undefined' &&
    'clipboard' in navigator &&
    (window.isSecureContext || location.hostname === 'localhost')
  ) {
    await navigator.clipboard.writeText(text)
    return
  }

  // legacy fallback API
  const ta = document.createElement('textarea')
  ta.value = text
  ta.setAttribute('readonly', '')
  ta.style.position = 'fixed'
  ta.style.top = '-9999px'
  document.body.appendChild(ta)
  ta.select()
  ta.setSelectionRange(0, ta.value.length) // iOS
  const ok = document.execCommand('copy')
  document.body.removeChild(ta)
  if (!ok) throw new Error('execCommand copy failed')
}

export { copyText }
